import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ee37590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inter-consultation py-56" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-lg-8"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uq-preloader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "expedients-list py-56"
}
const _hoisted_7 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_8 = { class: "h4 text-primary mb-0" }
const _hoisted_9 = { class: "fw-normal" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { class: "d-flex table-responsive" }
const _hoisted_12 = { class: "fit" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_15 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_16 = { class: "h5 title text-primary mb-0" }
const _hoisted_17 = { class: "text-truncate" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "badge bg-secondary text-xs mx-4"
}
const _hoisted_21 = {
  key: 1,
  class: "badge bg-primary text-xs text-white mx-4"
}
const _hoisted_22 = { class: "fit text-center" }
const _hoisted_23 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_the_professional_inter_consultation_create = _resolveComponent("the-professional-inter-consultation-create")!
  const _component_the_professional_inter_consultation = _resolveComponent("the-professional-inter-consultation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Listado de')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('interconsultas')), 1)
                ]),
                (_ctx.can('professional.inter-consultation.store'))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "secondary",
                      class: "new-consultation",
                      "aria-label": _ctx.$t('Nueva interconsulta'),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-professional-inter-consultation-create'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Nueva interconsulta')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_table, { class: "table-bordered" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table_header, null, {
                      default: _withCtx(() => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('Título')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('Descripción')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('Con')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('Paciente')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('F. Creación')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('Estado')), 1),
                          _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('Acciones')), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_table_body, null, {
                      default: _withCtx(() => [
                        (!_ctx.interConsultations.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                              _createElementVNode("td", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('No hay interconsultas')), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interConsultations, (interConsultation) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: interConsultation.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(interConsultation.title), 1),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(interConsultation.description), 1),
                            _createElementVNode("td", null, _toDisplayString(interConsultation.targetProfessional.name + ' ' + interConsultation.targetProfessional.surname), 1),
                            _createElementVNode("td", null, [
                              (!!interConsultation.expedient)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(// eslint-disable-next-line max-len
                        interConsultation.expedient?.patient.user.name + ' ' + interConsultation.expedient?.patient.user.surname), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t(' - Sin paciente - ')), 1))
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.$str.formatDateTime(interConsultation.createdAt)), 1),
                            _createElementVNode("td", null, [
                              (interConsultation.status === 'closed')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('Finalizada')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('Abierta')), 1))
                            ]),
                            _createElementVNode("td", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                (_ctx.can('professional.inter-consultation.get-index-by-creator'))
                                  ? (_openBlock(), _createBlock(_component_v_button, {
                                      key: 0,
                                      variant: "icon",
                                      class: "justify-content-center d-flex align-items-center flex-column p-4",
                                      "aria-label": _ctx.$t('Ver interconsulta'),
                                      onClick: ($event: any) => (_ctx.openInterconsultationView(interConsultation))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_24,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Ver')), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["aria-label", "onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ]),
    (_ctx.can('professional.inter-consultation.store') &&
      _ctx.modalToShow === 'the-professional-inter-consultation-create')
      ? (_openBlock(), _createBlock(_component_the_professional_inter_consultation_create, {
          key: 0,
          onInterConsultationCreated: _ctx.handleInterConsultationCreatedEvent,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["onInterConsultationCreated"]))
      : _createCommentVNode("", true),
    (_ctx.offCanvasToShow === 'off-canvas-inter-consultation')
      ? (_openBlock(), _createBlock(_component_the_professional_inter_consultation, {
          key: 1,
          onEmitRefreshInterConsultation: _ctx.refreshInterConsultation,
          onClosed: _cache[2] || (_cache[2] = ($event: any) => {_ctx.offCanvasToShow = null;})
        }, null, 8, ["onEmitRefreshInterConsultation"]))
      : _createCommentVNode("", true)
  ], 64))
}